import '@angular/compiler';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAdminUsersComponent } from './page.admin.users/page.admin.users.component';
import { PageAdminMaterialsComponent } from './page.admin.materials/page.admin.materials.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PagePendingComponent } from './page.pending/page.pending.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageAdminLibraryComponent } from './page.admin.library/page.admin.library.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAdminMaterialsDetailComponent } from './page.admin.materials.detail/page.admin.materials.detail.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAdminMaterialsNewComponent } from './page.admin.materials.new/page.admin.materials.new.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminResourcesComponent } from './page.admin.resources/page.admin.resources.component';

const INDEX_PAGE = "main";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "admin/users",
                component: PageAdminUsersComponent,
                "app_id": "page.admin.users"
            },
            {
                "path": "admin/materials",
                component: PageAdminMaterialsComponent,
                "app_id": "page.admin.materials"
            },
            {
                "path": "main/:book?",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "pending",
                component: PagePendingComponent,
                "app_id": "page.pending"
            },
            {
                "path": "",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            },
            {
                "path": "signup",
                component: PageSignupComponent,
                "app_id": "page.signup"
            },
            {
                "path": "admin/library",
                component: PageAdminLibraryComponent,
                "app_id": "page.admin.library"
            },
            {
                "path": "admin/materials/detail/:materialId",
                component: PageAdminMaterialsDetailComponent,
                "app_id": "page.admin.materials.detail"
            },
            {
                "path": "admin/materials/new",
                component: PageAdminMaterialsNewComponent,
                "app_id": "page.admin.materials.new"
            },
            {
                "path": "admin/resources",
                component: PageAdminResourcesComponent,
                "app_id": "page.admin.resources"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
